import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LoaderProvider } from './context/LoaderContext';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { EngineerDashboard } from './pages/EngineerDashboard';
import { SubmissionForm } from './pages/SubmissionForm';
import { ManagerDashboard } from './pages/ManagerDashboard';
import { ReviewForm } from './pages/ReviewForm';
import { Reports } from './pages/Reports';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { user } = useAuth();
    if (!user) {
        return <Navigate to="/login" replace />;
    }
    return <>{children}</>;
};

function AppRoutes() {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />

            <Route path="/" element={<Navigate to="/login" replace />} />

            <Route
                path="/engineer/*"
                element={
                    <ProtectedRoute>
                        <Layout>
                            <Routes>
                                <Route path="dashboard" element={<EngineerDashboard />} />
                                <Route path="submission/new" element={<SubmissionForm />} />
                                <Route path="submission/:id" element={<SubmissionForm />} />
                            </Routes>
                        </Layout>
                    </ProtectedRoute>
                }
            />

            <Route
                path="/manager/*"
                element={
                    <ProtectedRoute>
                        <Layout>
                            <Routes>
                                <Route path="dashboard" element={<ManagerDashboard />} />
                                <Route path="review/:submissionId" element={<ReviewForm />} />
                            </Routes>
                        </Layout>
                    </ProtectedRoute>
                }
            />

            <Route
                path="/reports"
                element={
                    <ProtectedRoute>
                        <Layout>
                            <Reports />
                        </Layout>
                    </ProtectedRoute>
                }
            />
        </Routes>
    );
}

function App() {
    return (
        <AuthProvider>
            <LoaderProvider>
                <Router>
                    <AppRoutes />
                </Router>
            </LoaderProvider>
        </AuthProvider>
    );
}

export default App;
